import { useEffect } from 'react'

/**
 * Hook to disable Google One Tap for specific experiment variants when user is not signed in
 * @param isUserSignedIn Whether the user is currently signed in
 */
export function useDisableGoogleOneTap(isUserSignedIn: boolean): void {
  useEffect(() => {
    // Only disable Google One Tap if the user is not signed in
    if (!isUserSignedIn) {
      let intervalId: NodeJS.Timeout | null = null

      const disableGoogleOneTap = () => {
        // Find and remove any Google One Tap elements
        const googleOneTapElements = window.document.querySelectorAll(
          '[id^="credential_picker_iframe"]'
        )

        if (googleOneTapElements.length > 0) {
          googleOneTapElements.forEach((element: Element) => {
            element.remove()
          })

          // Clear interval after removing google_one_tap
          if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
          }
        }
      }

      // Execute immediately and also set up an interval to handle delayed initialization
      disableGoogleOneTap()
      intervalId = setInterval(disableGoogleOneTap, 500)

      return () => {
        if (intervalId) {
          clearInterval(intervalId)
        }
      }
    }
  }, [isUserSignedIn])
}
